import { Button, Modal, Tag } from 'antd';
import { ClockCircleOutlined } from '@ant-design/icons';

import NotificationActionButtons from './NotificationActionButtons';
import {
  notificationLayerColor,
  notificationLayerLabel,
  notificationSeverityColor,
  notificationSeverityLabel,
} from '../../constants/notifications';
import { sanitizeNotificationBody } from '../../utils/notificationDisplay';

const NotificationDetailModal = ({ notification, open, onClose, onOpenAction, navigate }) => {
  if (!notification) return null;

  return (
    <Modal
      open={open}
      onCancel={onClose}
      title="متن اعلان"
      footer={[
        <Button key="close" onClick={onClose}>بستن</Button>,
      ]}
      width={620}
      centered
    >
      <div className="space-y-4 py-2">
        <div className="flex flex-wrap items-center gap-2">
          <Tag color={notification.is_read ? 'default' : 'blue'}>
            {notification.is_read ? 'خوانده‌شده' : 'خوانده‌نشده'}
          </Tag>
          <Tag color={notificationLayerColor(notification.layer)}>
            {notificationLayerLabel(notification.layer)}
          </Tag>
          <Tag color={notificationSeverityColor(notification.severity)}>
            {notificationSeverityLabel(notification.severity)}
          </Tag>
          {notification.created_at ? (
            <span className="inline-flex items-center gap-1 text-xs text-slate-500 dark:text-slate-400">
              <ClockCircleOutlined />
              {new Date(notification.created_at).toLocaleString('fa-IR')}
            </span>
          ) : null}
        </div>
        <h3 className="m-0 text-base font-bold leading-7 text-slate-900 dark:text-white">
          {notification.subject || 'اعلان'}
        </h3>
        <div className="whitespace-pre-line rounded-xl bg-slate-50 p-4 text-sm leading-8 text-slate-700 dark:bg-white/[0.04] dark:text-slate-200">
          {sanitizeNotificationBody(notification.body) || 'متنی برای این اعلان ثبت نشده است.'}
        </div>
        <NotificationActionButtons
          notification={notification}
          navigate={navigate || ((url) => onOpenAction?.(url))}
          onNavigate={onClose}
        />
      </div>
    </Modal>
  );
};

export default NotificationDetailModal;
